/**
 * Project: depilujma
 * Owner: depilujma
 * Author: Peter Golembiovský
 * Year: 2026
 * Copyright (c) 2026 depilujma. All rights reserved.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
